"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddPhone = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var react_redux_1 = require("react-redux");
var pp_react_1 = require("@paypalcorp/pp-react");
var constants_1 = require("../../../constants");
var phones_1 = require("../../../actions/phones");
var commonweb_utils_1 = require("commonweb-utils");
var commonUtils_1 = require("../../../common/utils/commonUtils");
var interpolate_1 = require("../../../utils/interpolate/interpolate");
var ajax_util_1 = require("../../../utils/ajax/ajax.util");
var ErrorContentMapper_1 = require("../../../utils/errorcodes/ErrorContentMapper");
var interpolate_component_1 = require("../../../components/interpolate-component");
var triggerOperationResult_1 = require("../../../utils/fpti/triggerOperationResult");
var phone_1 = require("../../../utils/container/phone");
var utils_1 = require("../../../common/utils/phones/utils");
var beaver_logger_1 = require("../../../utils/logging/beaver-logger");
var constants_2 = require("../name/constants");
var constants_3 = require("./constants");
var page = require("page");
var AddPhone = /** @class */ (function (_super) {
    tslib_1.__extends(AddPhone, _super);
    function AddPhone(props) {
        var _this = _super.call(this, props) || this;
        _this.inputChangedHandler = function (event) {
            _this.setState({
                newNumber: event.target.value,
                errorMessage: "",
                blankFieldError: "",
            });
        };
        _this.countrySelectionHandler = function (event) {
            var chosenDropdownCountryObject = utils_1.findCountryObjectInCountriesList(_this.props.countries, event.target.value);
            _this.setState({
                errorMessage: "",
                enableTcpa: chosenDropdownCountryObject.countryCode === "US",
                chosenCountryObject: chosenDropdownCountryObject,
            });
        };
        _this.categorySelectionHandler = function (event) {
            var category = event.target.value;
            _this.setState({ errorMessage: "", category: category });
        };
        _this.setTcpaPreference = function (event) {
            if (!_this.state.showSpinner) {
                if (event.target.id.startsWith("callTcpa"))
                    _this.setState({
                        errorMessage: "",
                        newCallPref: !_this.state.newCallPref,
                    });
                if (event.target.id.startsWith("smsTcpa"))
                    _this.setState({
                        errorMessage: "",
                        newTextPref: !_this.state.newTextPref,
                    });
            }
            else {
                event.preventDefault();
            }
        };
        _this.phoneConfirmable = function (phoneType, isMobileCowConfirmable, optedTextNotification, isEnableTcpa) {
            var phoneConfirmable = phone_1.phoneHasConfirmationFeature(phoneType, isMobileCowConfirmable);
            if (isEnableTcpa && !optedTextNotification) {
                phoneConfirmable = false;
            }
            return phoneConfirmable;
        };
        _this.initiatePhoneConfirmation = function (phone) {
            event.preventDefault();
            var url = constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.PHONES.VALIDATE_CONFIRMATION;
            url = url.replace(":id", phone.id);
            var formData = {};
            formData["id"] = phone.id;
            formData["isTcpaEnabled"] = _this.state.enableTcpa;
            formData["isSCAEnabled"] = utils_1.isSCAEnabled(_this.props.features);
            ajax_util_1.default.post$(_this.props.dispatch, _this.props._csrf, "" + constants_1.default.ROUTES.API.PHONES.CONFIRM, formData, { component: { name: constants_1.default.VIEWS.PHONES.MANAGE } })
                .then(function (phoneInfo) {
                page(url);
            })
                .catch(function (error) {
                page(url);
                return;
            });
        };
        _this.submitHandler = function (event) {
            event.preventDefault();
            _this.setState({ errorMessage: "" });
            var formData = {};
            var phoneType = _this.state.category, url = _this.props.isAddView
                ? "" + constants_1.default.ROUTES.API.PHONES.ADD
                : "" + constants_1.default.ROUTES.API.PHONES.EDIT, isTcpaUpdated = phone_1.isTcpaChanged(_this.state.currentCallPref, _this.state.currentTextPref, _this.state.newCallPref, _this.state.newTextPref);
            formData["id"] = _this.state.id;
            formData["countryCode"] = _this.getCountryCallingCode();
            //Trimming spaces in number entered by user
            if (_this.state.newNumber.trim() === "") {
                // Blank field error, showing on banner & instrumentation
                var errorMessage = _this.props.content.common.genericBlankFieldError;
                _this.setState({ blankFieldError: errorMessage });
                triggerOperationResult_1.triggerOperationResult(_this.props.phoneFpti.changePrimary, constants_1.default.FPTI.FAILURE, errorMessage);
                return;
            }
            formData["subscriberNumber"] = _this.state.newNumber;
            formData["primary"] = false;
            formData["type"] = phoneType;
            formData["callPref"] = _this.state.newCallPref;
            formData["textPref"] = _this.state.newTextPref;
            formData["isTcpaEnabled"] = _this.state.enableTcpa;
            formData["isSCAEnabled"] = utils_1.isSCAEnabled(_this.props.features);
            formData["isTcpaUpdated"] = isTcpaUpdated;
            // Start the spinner on submission
            _this.setState({ showSpinner: true });
            // API call
            ajax_util_1.default.post$(_this.props.dispatch, _this.props._csrf, url, formData, { component: { name: constants_1.default.VIEWS.PHONES.ADD } } // Same view reused for add & edit
            )
                .then(function (phoneInfo) {
                // Extract currently added number from state
                var phone = phone_1.findAddedPhone(phoneInfo.phones, _this.state.phoneList), isPhoneConfirmable = phone &&
                    _this.phoneConfirmable(phoneType, phone.isMobileCowConfirmable, _this.state.newTextPref, _this.state.enableTcpa);
                // After number addition / updation, if it is confirmable redirect to Phone Confirmation screen
                if (phone && isPhoneConfirmable) {
                    _this.props.dispatchPhoneAdd(phoneInfo);
                    _this.initiatePhoneConfirmation(phone);
                } // Else redirect to Manage screen.
                else {
                    // Set toast intent
                    var toastIntent = _this.props.isAddView
                        ? constants_1.default.VIEWS.PHONES.TOAST_INTENTS.ADD
                        : constants_1.default.VIEWS.PHONES.TOAST_INTENTS.EDIT;
                    // Set attribute for NEW/UPDATED tags
                    if (phone && phoneInfo && phoneInfo.phones) {
                        phoneInfo.phones = commonUtils_1.modifyObjectWithFactorById(phoneInfo.phones, phone.id, toastIntent, true);
                    }
                    // Dispatch to store and stop spinner
                    _this.props.performedAction(toastIntent);
                    _this.props.dispatchPhoneAdd(phoneInfo);
                    _this.setState({ showSpinner: false });
                    // In case of phone add / edit, take to PP-Credit profile update screen (when only Tcpa changed, phone will be undefined)
                    if (phone &&
                        phoneInfo &&
                        phoneInfo.ppcSynchronyDeeplinks &&
                        Object.keys(phoneInfo.ppcSynchronyDeeplinks).length != 0) {
                        var ppcUpdate = constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.PHONES.UPDATE_PPC;
                        page.redirect(ppcUpdate);
                    }
                    else {
                        page.redirect(constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.PHONES.MANAGE);
                    }
                }
            })
                .catch(function (error) {
                // Get Error content from error object & instrument
                var errorMessage = ErrorContentMapper_1.getPhoneErrorContent(error, _this.props.content), operationType = _this.props.isAddView
                    ? _this.props.phoneFpti.addNew
                    : _this.props.phoneFpti.edit;
                beaver_logger_1.default().info(constants_3.PHONE.ADD_PHONE, {
                    message: errorMessage,
                });
                triggerOperationResult_1.triggerOperationResult(operationType, constants_1.default.FPTI.FAILURE, errorMessage);
                // STEP UP AUTH Error
                if (errorMessage && errorMessage.includes("stepupContext")) {
                    var url_1 = window.origin.concat(errorMessage);
                    window.location.assign(url_1);
                    return;
                }
                // Already Exists Error
                else if (errorMessage &&
                    errorMessage.includes("alreadyExists")) {
                    var errorContent = errorMessage.split("-");
                    errorMessage = errorContent[1];
                    if (_this.state.enableTcpa && isTcpaUpdated) {
                        _this.callSetTcpaAPI(formData);
                    }
                    else {
                        _this.setState({
                            showSpinner: false,
                            errorMessage: errorMessage,
                        });
                        return;
                    }
                }
                else {
                    _this.setState({
                        showSpinner: false,
                        errorMessage: errorMessage,
                    });
                    return;
                }
            });
        };
        var updatePhoneId = _this.props.route.enter.params.id, phonesList = _this.props.phones, category = _this.props.changePrimaryType != ""
            ? _this.props.changePrimaryType
            : "MOBILE", maskedSubscriberNumber = "", phoneToBeUpdated, accountCountryCode = phonesList &&
            phonesList.length > 0 &&
            phonesList[0].accountCountryCode, defaultCountryCode = accountCountryCode, enableTcpa = phonesList &&
            phonesList.length > 0 &&
            phonesList[0].accountCountryCode === "US", confirmed = false, currentCallPref = true, currentTextPref = true, isMobileCowConfirmable = false;
        if (!_this.props.isAddView) {
            phoneToBeUpdated = commonUtils_1.findObjectInListById(phonesList, updatePhoneId);
        }
        if (phoneToBeUpdated) {
            maskedSubscriberNumber = phoneToBeUpdated.maskedSubscriberNumber;
            defaultCountryCode = phoneToBeUpdated.region;
            enableTcpa = phone_1.isTcpaEnabled(phoneToBeUpdated, _this.props);
            category = phoneToBeUpdated.type;
            confirmed = phoneToBeUpdated.confirmed;
            currentCallPref = phoneToBeUpdated.callPref;
            currentTextPref = phoneToBeUpdated.textPref;
            isMobileCowConfirmable = phoneToBeUpdated.isMobileCowConfirmable;
        }
        var defaultCountryObject = utils_1.findCountryObjectInCountriesList(_this.props.countries, defaultCountryCode);
        if (!defaultCountryObject) {
            defaultCountryObject = utils_1.findCountryObjectInCountriesList(_this.props.countries, accountCountryCode);
        }
        _this.state = {
            id: commonweb_utils_1.objectUtils.safeGet(_this.props, "route.enter.params.id") || "",
            enableTcpa: enableTcpa,
            subscriberNumber: maskedSubscriberNumber,
            confirmed: confirmed,
            newNumber: "",
            category: category,
            currentCallPref: currentCallPref,
            currentTextPref: currentTextPref,
            newCallPref: currentCallPref,
            newTextPref: currentTextPref,
            chosenCountryObject: defaultCountryObject,
            errorMessage: "",
            showSpinner: false,
            blankFieldError: "",
            phoneList: phonesList,
            isMobileCowConfirmable: isMobileCowConfirmable,
        };
        return _this;
    }
    AddPhone.prototype.componentDidMount = function () {
        window.scroll({
            top: 0,
            behavior: "smooth",
        });
    };
    AddPhone.prototype.callSetTcpaAPI = function (formData) {
        var _this = this;
        ajax_util_1.default.post$(this.props.dispatch, this.props._csrf, "" + constants_1.default.ROUTES.API.PHONES.SET_TCPA, formData, { component: { name: constants_1.default.VIEWS.PHONES.ADD } })
            .then(function (phoneInfo) {
            var phoneId = commonweb_utils_1.objectUtils.safeGet(_this.props.route, "enter.params.id"), toastIntent = constants_1.default.VIEWS.PHONES.TOAST_INTENTS.EDIT;
            if (phoneInfo && phoneInfo.phones) {
                phoneInfo.phones = commonUtils_1.modifyObjectWithFactorById(phoneInfo.phones, phoneId, toastIntent, true);
            }
            _this.props.dispatchPhoneAdd(phoneInfo);
            _this.props.performedAction(constants_1.default.VIEWS.PHONES.TOAST_INTENTS.EDIT);
            _this.setState({ showSpinner: false });
            page.redirect(constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.PHONES.MANAGE);
        })
            .catch(function (error) {
            _this.setState({
                showSpinner: false,
                errorMessage: ErrorContentMapper_1.getPhoneErrorContent(error, _this.props.content),
            });
            beaver_logger_1.default().info(constants_2.NAME.SET_TCPA, {
                message: error && error.message,
            });
            window.scroll({
                top: 0,
                behavior: "smooth",
            });
            return;
        });
    };
    AddPhone.prototype.getCountryCallingCode = function () {
        var phonesList = this.props.phones, defaultCountryCode = phonesList &&
            phonesList.length > 0 &&
            phonesList[0].accountCountryCode;
        return (commonweb_utils_1.objectUtils.safeGet(this.state, "chosenCountryObject.countryPhoneCode") ||
            defaultCountryCode);
    };
    AddPhone.prototype.render = function () {
        var _this = this;
        var phoneContent = this.props.content.phones, commonContent = this.props.content.common, categoryDropdownValue = this.state.category, chosenCallingCode = this.getCountryCallingCode(), chosenCountryCode = this.state.chosenCountryObject.countryCode, countryList = this.props.countries.map(function (country) {
            var countryLabel = country && country.countryName
                ? country.countryName + "  +" + country.countryPhoneCode
                : "  +" + country.countryPhoneCode;
            return {
                label: countryLabel,
                value: country.countryCode,
            };
        }), countryListOptions = tslib_1.__spreadArrays([
            {
                label: " +" + chosenCallingCode,
                value: chosenCountryCode,
            }
        ], countryList), categoryList = [
            {
                label: phoneContent.category.mobile,
                value: "MOBILE",
            },
            {
                label: phoneContent.category.work,
                value: "WORK",
            },
            {
                label: phoneContent.category.home,
                value: "HOME",
            },
        ], currentPhoneComponent = {
            __html: interpolate_1.default("inDoubleQuotedAttr", phoneContent.current.label, {
                phoneNumber: this.state.subscriberNumber,
            }),
        }, phoneFpti = this.props.phoneFpti, submitEventFpti = this.props.isAddView
            ? phoneFpti.submitAdd
            : phoneFpti.submitEdit, privacyPolicyLinkComponent = (React.createElement(pp_react_1.Link, { key: "linkUrl", href: this.props.links.privacy.linkUrl }, phoneContent.nontcpa.privacypolicy)), modifiedNonTCPAContent = interpolate_component_1.InterpolateLinksWithComponent(phoneContent.nontcpa.description, [privacyPolicyLinkComponent]), callTcpaTrackingValue = "callTcpa_", smsTcpaTrackingValue = "smsTcpa_", isInternationalPhonesEnabled = utils_1.isSCAEnabled(this.props.features), phoneInputClass = isInternationalPhonesEnabled
            ? "addPhone-input_international-enabled"
            : "addPhone-input_international-disabled", dataTrackValue = JSON.stringify({
            countryCode: chosenCountryCode,
            phoneCategory: categoryDropdownValue,
        });
        // When callPref is true, we append OFF because when it is clicked it is getting turned OFF from ON. So current value is on, but tracking value is OFF
        callTcpaTrackingValue += this.state.newCallPref ? "OFF" : "ON";
        smsTcpaTrackingValue += this.state.newTextPref ? "OFF" : "ON";
        var form = (React.createElement("form", { onSubmit: this.submitHandler },
            this.state.errorMessage ? (React.createElement(pp_react_1.Alert, { type: "error", className: "alignLeft nameAlert" }, this.state.errorMessage)) : null,
            this.props.isAddView ? (React.createElement(pp_react_1.Text, { size: "xl3", className: "alignLeft addPhone-header" }, phoneContent.addNew.header)) : (React.createElement(pp_react_1.Text, { size: "xl3", className: "alignLeft addPhone-header" }, phoneContent.edit.header)),
            !this.props.isAddView &&
                categoryDropdownValue == "MOBILE" &&
                !this.state.confirmed &&
                phone_1.phoneHasConfirmationFeature(categoryDropdownValue, this.state.isMobileCowConfirmable) && (React.createElement("div", { className: "alignLeft" },
                React.createElement(pp_react_1.Badge, { className: "badgeComponent", type: "critical" }, commonContent.unconfirmed))),
            React.createElement("div", null,
                isInternationalPhonesEnabled && (React.createElement(pp_react_1.Dropdown, { className: this.state.blankFieldError
                        ? "addPhone-dropdown_countries_err"
                        : "addPhone-dropdown_countries", label: phoneContent.countryCode.label, options: countryListOptions, disabled: this.state.showSpinner, onChange: function (event) {
                        return _this.countrySelectionHandler(event);
                    } })),
                React.createElement(pp_react_1.TextInput, { className: phoneInputClass, name: "phoneNumber", id: "test_phoneNumber", value: this.state.newNumber, label: phoneContent.placeholder, disabled: this.state.showSpinner, onChange: function (event) { return _this.inputChangedHandler(event); }, errorText: this.state.blankFieldError })),
            !this.props.isAddView && (React.createElement(pp_react_1.Text, { size: "md", className: "alignLeft addPhone-subheader" },
                React.createElement("span", { dangerouslySetInnerHTML: currentPhoneComponent }))),
            React.createElement("div", { className: this.props.changePrimaryType
                    ? "addPhone-dropdown_category_disabled"
                    : null },
                React.createElement(pp_react_1.Dropdown, { className: "addPhone-dropdown_category", label: phoneContent.category.placeholder, id: "test_phoneCategory", value: categoryDropdownValue, options: categoryList, disabled: this.state.showSpinner ||
                        this.props.changePrimaryType != "", onChange: function (event) {
                        return _this.categorySelectionHandler(event);
                    } })),
            React.createElement("div", null, this.state.enableTcpa ? (React.createElement("div", null,
                React.createElement(pp_react_1.Text, { size: "md", className: "alignLeft addPhone-tcpa_desc" }, phoneContent.tcpa.description),
                React.createElement(pp_react_1.Checkbox, { id: callTcpaTrackingValue, name: callTcpaTrackingValue, className: "addPhone-tcpa_checkbox block-display", onChange: function (event) {
                        return _this.setTcpaPreference(event);
                    }, checked: this.state.newCallPref }),
                React.createElement(pp_react_1.Text, { size: "md", className: "alignLeft addPhone-tcpa_title block-display" }, phoneContent.tcpa.callsPreference.title),
                React.createElement(pp_react_1.Text, { size: "sm", className: "alignLeft addPhone-tcpa_subtitle" }, phoneContent.tcpa.callsPreference.subtitle),
                React.createElement(pp_react_1.Divider, { secondary: true, className: "divider-symmetrical" }),
                React.createElement(pp_react_1.Checkbox, { id: smsTcpaTrackingValue, name: smsTcpaTrackingValue, className: "addPhone-tcpa_checkbox block-display", onChange: function (event) {
                        return _this.setTcpaPreference(event);
                    }, checked: this.state.newTextPref }),
                React.createElement(pp_react_1.Text, { size: "md", className: "alignLeft addPhone-tcpa_title block-display" }, phoneContent.tcpa.textPreference.title),
                React.createElement(pp_react_1.Text, { size: "sm", className: "alignLeft addPhone-tcpa_subtitle" }, phoneContent.tcpa.textPreference.subtitle))) : (React.createElement("div", null,
                React.createElement(pp_react_1.Text, { size: "md", className: "alignLeft addPhone-nontcpa_desc" }, modifiedNonTCPAContent)))),
            React.createElement(pp_react_1.Button, { type: "submit", className: "addPhone-submit_button", id: "test_addUpdatePhoneButton", disabled: this.state.showSpinner, "data-name": submitEventFpti, "data-track": dataTrackValue }, this.state.showSpinner ? (React.createElement(pp_react_1.LoadingSpinner, { className: "loading-spinner", screenReaderText: "loading", inverse: true })) : this.props.isAddView ? (React.createElement(pp_react_1.Text, { size: "md", medium: true }, phoneContent.add.button)) : (React.createElement(pp_react_1.Text, { size: "md", medium: true }, commonContent.update)))));
        return React.createElement("div", { className: "generic-container" }, form);
    };
    return AddPhone;
}(React.Component));
exports.AddPhone = AddPhone;
var mapStateToProps = function (_a) {
    var _csrf = _a._csrf, ui = _a.ui, content = _a.content, route = _a.route, account = _a.account, links = _a.links, fpti = _a.fpti, features = _a.features;
    var phones = commonweb_utils_1.objectUtils.safeGet(account, "phones.phones") || {}, countries = commonweb_utils_1.objectUtils.safeGet(account, "phones.countries") || {}, changePrimaryType = commonweb_utils_1.objectUtils.safeGet(account, "phones.changePrimaryType") || "", phoneFpti = fpti.phones, exitView = route.exit && route.exit.view, hasCallOriginatedFromChangePrimary = exitView && exitView == "change-primary-phone" ? true : false, isAddView = true, enterParams = route.enter && route.enter.params && route.enter.params[0];
    if (enterParams == "/flow" + constants_1.default.ROUTES.PHONES.ADD) {
        isAddView = true;
    }
    else {
        isAddView = false;
    }
    phones = utils_1.changeNumberFormatForNonSCARegions(phones, utils_1.isSCAEnabled(features));
    return {
        _csrf: _csrf,
        ui: ui,
        content: content,
        route: route,
        phones: phones,
        countries: countries,
        changePrimaryType: changePrimaryType,
        phoneFpti: phoneFpti,
        hasCallOriginatedFromChangePrimary: hasCallOriginatedFromChangePrimary,
        isAddView: isAddView,
        features: features,
        links: links,
    };
};
function mapDispatchToProps(dispatch) {
    return {
        dispatchPhoneAdd: function (phones) { return dispatch(phones_1.changePhone(phones)); },
        performedAction: function (typeOfAction) {
            return dispatch(phones_1.actionClicked(typeOfAction));
        },
        dispatch: dispatch,
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(AddPhone);
